export const WHATSAPP_COMMUNITY_URL =
  "https://chat.whatsapp.com/IrAmcqSJDGS8uVcC4mO4Qt?mode=gi_t";
